/**
 * lebron answers a complete/skip of a task that already left PENDING with
 * 409 `{ detail: "task_already_finalized" }` — a double-click, a retry after
 * a timeout, or the same task open in a second tab. The task is done either
 * way, so callers move on to the next task instead of treating it as a
 * failure.
 */
export const isTaskAlreadyFinalized = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  (error as { detail?: unknown }).detail === "task_already_finalized";
